import { Form } from "react-bootstrap";
import "../style/style-register.css";
import { useState } from "react";
import axios from "../axios/axios";
import Cookies from "js-cookie";
import Swal from "sweetalert2";

export default function SendLinkResetPassWord() {
  const token = Cookies.get("auth_token");

  const [email, setEmail] = useState("");
  const [success, setSuccess] = useState(null);
  const [error, setError] = useState(null);

  const sendLinkResetPassWord = (e) => {
    e.preventDefault();

    Swal.fire({
      title: "Traitement en cours, veuillez patienter ...",
      showConfirmButton: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    const form = new FormData();
    form.append("email", email);

    axios
      .post("/sendLinkResetPassWord", form, {
        headers: {
          Accept: "application/json",
        },
      })
      .then((response) => {
        // return 0;
        setSuccess(response.data.success);
        setError(response.data.message);
        Swal.close();
      })
      .catch((err) => {
        console.log(err);
        Swal.close();
      });
  };

  return (
    <div id="section" className="signup">
      <div className="container card">
        <div className="row bg-light">
          <div className="col-sm-12">
            <center>
              <h4 style={{ fontWeight: "900", padding: "10px" }}>
                Réinitialiser le mot de passe
              </h4>
            </center>
          </div>
        </div>

        <div className="signup-content">
          <Form
            id="signup-form"
            className="signup-form"
            onSubmit={sendLinkResetPassWord}
          >
            <div className="row">
              {success != null ? (
                <div className="alert alert-success col-sm-12 text-center">
                  {" "}
                  {success}{" "}
                </div>
              ) : null}

              <div className="form-group col-sm-12">
                <label>Email</label>
                <input
                  type="email"
                  required
                  className="form-input"
                  value={email}
                  onChange={(e) => {
                    setEmail(e.target.value);
                    setError(null);
                  }}
                  placeholder="E-mail"
                />
                {error != null ? (
                  <div className="alert alert-danger col-sm-12 text-center">
                    {" "}
                    {error}{" "}
                  </div>
                ) : null}
              </div>

              <div className="form-group col-sm-12 ">
                <button
                  type="submit"
                  className="btn "
                  style={{
                    borderRadius: "25px",
                    float: "right",
                    fontWeight: "900",
                    background: "#047104",
                    color: "#fff",
                  }}
                >
                  Réinitialiser votre mot de passe
                </button>
              </div>
            </div>
          </Form>
        </div>
      </div>
    </div>
  );
}
